import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import Select from '@jetbrains/ring-ui/components/select/select';
import InlineLoader from '@jetbrains/ring-ui/components/loader-inline/loader-inline';
import { usePluginChannels } from '@common/queries/plugins';
import { assignTestId } from '@common/infra/tests/assign-test-id';
export function ChannelSelector(props) {
    const { pluginId, onChannelChange, channel, className } = props;
    const { data, isFetching } = usePluginChannels(pluginId);
    const options = useMemo(() => {
        if (!data) {
            return [];
        }
        return data.items.map(channel => ({
            label: channel.name,
            key: channel.id,
            channel: { id: channel.id, name: channel.name }
        }));
    }, [data]);
    const selectedChannel = options.find(option => option.channel.id === (channel === null || channel === void 0 ? void 0 : channel.id));
    const handleSelect = (item) => {
        if (item) {
            onChannelChange(item === null || item === void 0 ? void 0 : item.channel);
        }
    };
    if (isFetching) {
        return _jsx(InlineLoader, {});
    }
    return (_jsx(Select, { ...assignTestId('channel-selector'), onSelect: handleSelect, selected: selectedChannel, className: className, data: options, label: "Custom channel" }));
}
